import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import Card from "../components/ui/Card";
import Button from "../components/ui/Button";

function ResetPasswordSuccessPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (countdown <= 0) {
      navigate("/");
      return;
    }
    const timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  return (
    <div className="min-h-screen bg-app-paper px-4 py-10 md:px-8">
      <div className="mx-auto max-w-xl">
        <Card className="animate-fade-up text-center">
          <h1 className="ui-title text-xl">
            {t("new-ui.reset-success.title", { defaultValue: "Password updated" })}
          </h1>
          <p className="ui-copy mt-3">
            {t("new-ui.reset-success.description", {
              defaultValue: "Your password has been changed successfully."
            })}
          </p>
          <p className="ui-copy mt-2 text-sm text-app-muted">
            {t("new-ui.reset-success.redirect", {
              defaultValue: "Redirecting to login in {{seconds}} seconds...",
              seconds: countdown
            })}
          </p>
          <div className="mt-4">
            <Button onClick={() => navigate("/")}>
              {t("new-ui.reset-success.go-to-login", { defaultValue: "Go to login now" })}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default ResetPasswordSuccessPage;
